<template>
<div :class="$style['select-coupon-list']">
<pt-page-factor-filter :labels="couponNameTabs" v-model="params">
<el-button type="primary" @click="seachCoupon">搜索</el-button>
</pt-page-factor-filter>
<component :is="componentName" :tableLabels="couponForPromotionLabels" @getTableData="getTableData" :total-count="totalCount" :table-data="tableData" subFiled="couponData"
 showName="name" @selected="selected" :selected-rows="selectRow">
    <template slot="before">
        <el-table-column label="优惠劵名称">
            <template slot-scope="scope">
                {{scope.row.couponData&&scope.row.couponData.name}}
            </template>
        </el-table-column>
        <el-table-column label="内容">
            <template slot-scope="scope">
                <div>{{scope.row.discount}}</div>
                <div>满{{scope.row.thresholdOfAmount}}元可使用</div>
            </template>
        </el-table-column>
        <slot/>
    </template>
</component>
  <div class="button-div">
        <el-button type="primary" @click="submit">选择</el-button>
        <el-button type="primary" plain @click="cancel">取消</el-button>
    </div>
</div>
</template>
<script>
import ptSelectList from 'cps/base/pt-select-list'
import ptRadioList from 'cps/base/pt-radio-list'
import { couponNameTabs, couponForPromotionLabels } from './promotion-option'
export default {
  components: {
    ptSelectList,
    ptRadioList
  },
  props: {
    pageSize: {
      type: Number,
      default: 5
    },
    selectedCoupon: {
      type: [Array, Object],
      default: function () {
        return []
      }
    },
    couponParams: {
      type: Object,
      default: function () {
        return {

        }
      }
    },
    isRadio: Boolean,
    grantType: String
  },
  computed: {
    componentName () {
      return this.isRadio ? 'pt-radio-list' : 'pt-select-list'
    }
  },
  data () {
    return {
      couponNameTabs: couponNameTabs,
      couponForPromotionLabels: couponForPromotionLabels,
      params: {},
      page_size: this.pageSize,
      tableData: [],
      totalCount: 0,
      selectRow: JSON.parse(JSON.stringify(this.selectedCoupon))
    }
  },
  methods: {
    seachCoupon () {
      for (var key in this.params) {
        if (!this.params[key]) {
          this.$delete(this.params, key)
        }
      }
      this.getTableData(0)
    },
    selected (val) {
      this.selectRow = val
    },
    submit () {
      console.log('this.selectRow', this.selectRow)
      this.$emit('selectCouponSubmit', this.selectRow)
    },
    cancel () {
      this.$emit('close')
    },
    getTableData (page, next) {
      let data = {
        isValid: true,
        example: {
          grantType: this.grantType || 'BY_OTHER_PROMOTION',
          status: 'ACTIVATED',
          couponData:
          { ...this.couponParams, ...this.params }
        },
        pageableParam: {
          page: page,
          size: this.page_size
        }
      }
      this.$store.dispatch('getCouponsList', data).then(res => {
        if (next) {
          next(res.data)
        }
        this.tableData = res.data
        this.totalCount = res.totalNumber
      }).catch(err => {
        this.$message.error(err || '获取优惠劵列表失败')
      })
    }
  },
  created () {
  }
}
</script>
<style module lang="less">
.select-coupon-list{

}
</style>
